// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment_root_3uood","badges":"Comment_badges_35cVD","controls":"Comment_controls_2Vdcw","answer":"Comment_answer_3XuKq"};